import React, { useCallback, useMemo } from 'react'
import PointSvg from '../svg/PointSvg';
// import Avatar from '@material-ui/core/Avatar';
import BottomNavigation from '@material-ui/core/BottomNavigation';
import BottomNavigationAction from '@material-ui/core/BottomNavigationAction';
import makeStyles from '@material-ui/core/styles/makeStyles';
import MenuIcon from '@material-ui/icons/Menu';
import { useTranslation } from 'react-i18next';
import MobileUserSvg from '../svg/MobileUserSvg';
import { classNames } from '../functions/classNames';
import { useHistory } from 'react-router-dom';
import CartComponent from './CartComponent';
import { useCookies } from 'react-cookie';
import { RAMI_ONLINE_USER_NAME_COOKIES, RAMI_ONLINE_USER_AVATAR_COOKIES, RAMI_ONLINE_LOGIN, RAMI_ONLINE_CART, AVATAR_LINK, RAMI_ONLINE_URL } from '../constants';
import routeGenerate from '../functions/routeGenerate';
import preloadPages from '../functions/preloadPages';
import loadable from '@loadable/component'
import { ROUTES } from '../constants/routes';
const Avatar = loadable(() => import('@material-ui/core/Avatar'))

const useStyles = makeStyles((theme) => ({
    menu: {
        width: 30,
        height: 30,
    },
    root: {
        display: 'none',
        backgroundColor: theme.palette.secondary.main,
        position: 'fixed',
        zIndex: 4,
        width: '100%',
        height: 'auto',
        alignItems: 'flex-end',
        bottom: 0,
        transition: 'bottom 0.2s ease-out',
        [theme.breakpoints.down('sm')]: {
            display: 'flex',
            bottom: 0
        }
    },
    shoppingCartIcon: {
        '& .ShopCart': {
            fill: theme.palette.primary.main,
        }
    },
    iconSize: {
        marginTop: 3,
        marginBottom: 2,
        width: 25,
        height: 25,
        [theme.breakpoints.down('xs')]: {
            width: 22,
            height: 22,
        } 
    },
    text: {
        maxWidth: 'none',
        color: theme.palette.primary.main,
        paddingBottom: 5,
    }
}));


const BottomNavigationComponent = ({ handleShowSideMenu = () => { } }) => {
    const [cookies] = useCookies();
    const userAvatar = useMemo(() => cookies[RAMI_ONLINE_USER_AVATAR_COOKIES], [cookies])
    const classes = useStyles();
    const { t } = useTranslation();
    const history = useHistory();
    const label = useMemo(() => cookies[RAMI_ONLINE_USER_NAME_COOKIES], [cookies]);

    const handleRoute = useCallback(() => {
        history.push(routeGenerate(ROUTES['contact']))
    }, [ history])
    const handleHref = useCallback((href) => {
        window.location.href = `${RAMI_ONLINE_URL}${href}`;
    }, [])
    const handlePreloadPages = useCallback(() => {
        preloadPages();
    }, [])
    return (
        <BottomNavigation
            showLabels
            className={classes.root}
            onMouseOver={handlePreloadPages}
        >
            <BottomNavigationAction
                className={classes.text}
                onClick={handleShowSideMenu}
                label={t('menu.mobile_title')}
                icon={<MenuIcon
                    className={classes.menu}
                    color='primary' />}
            />
            <BottomNavigationAction
                className={classes.text}
                onClick={handleRoute}
                label={t('menu.mobile_offices')}
                icon={<PointSvg className={classes.iconSize} />}
            />
            <BottomNavigationAction
                className={classes.text}
                label={label || t('menu.login')}
                onClick={() => handleHref(RAMI_ONLINE_LOGIN)}
                icon={
                    userAvatar
                        ? <Avatar
                            src={`${RAMI_ONLINE_URL}${AVATAR_LINK}${userAvatar}`}
                            className={classNames([classes.iconSize, classes.useIcon])}
                            alt={label || t('menu.login')}
                        />
                        : <MobileUserSvg className={classes.iconSize} />
                }
            />
            <BottomNavigationAction
                className={classes.text}
                label={t('menu.mobile_cart')}
                onClick={() => handleHref(RAMI_ONLINE_CART)}
                icon={
                    <CartComponent className={classNames([classes.shoppingCartIcon, classes.iconSize])} />
                }
            />
        </BottomNavigation>
    )
}


export default React.memo(BottomNavigationComponent);